const notifications = {
  invalid_email: 'Invalid email address.',
  invalid_phone: 'Invalid phone number.',
  at_least_one_contact_required: 'Please provide at least one email or phone.',
};

export default notifications;
